const SaltCrystal = ({
	height = 14,
	width = 10,
	color = "#4F6168",
}: {
	height?: number;
	width?: number;
	color?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 10 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.63546 0.333374L9.26667 7.34842L9.23618 9.64608L8.2076 12.3791L5.39848 13.6667L2.06639 12.1399L0.781234 9.58523L0.733337 7.16631L4.63546 0.333374ZM4.69414 2.14965L1.68987 7.41038L1.72828 9.35022L2.76615 11.4133L5.39841 12.6195L7.4552 11.6767L8.28697 9.46663L8.31136 7.62876L4.69414 2.14965Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.68086 9.47009L5.87318 13.1177L4.92299 13.1679L4.80991 11.0232L2.64205 12.1952L2.18976 11.3575L5.68086 9.47009Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.16474 7.72079L4.21032 1.10059L5.11937 1.38184L3.01318 8.1982L1.61101 9.78299L0.89859 9.15185L2.16474 7.72079Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.22653 1.42706L5.10267 1.05566L7.96081 7.80677L9.13148 9.25708L8.39127 9.85534L7.13674 8.30114L4.22653 1.42706Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.27856 8.32042L2.8991 7.59863L5.2296 9.60482L7.22096 7.70893L7.87683 8.39872L5.26174 10.8885L2.27856 8.32042Z"
				fill={color}
			/>
		</svg>
	);
};

export default SaltCrystal;
